export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.order_form_batch_label_orderBatchNo') || '交货批次号',
    field: 'orderBatchNo',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('INDEX.order_form_label_orderNo') || '订单编号',
    field: 'orderNo',
    width: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_batch_label_shipmentStartDate') || '客户最早交期',
    field: 'shipmentDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('INDEX.order_form_batch_label_shipmentEndDate') || '客户最晚交期',
    field: 'shipmentEndDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  // {
  //   title: that.$l('INDEX.form_label_articleNoDate') || '货好日期(订舱)',
  //   field: 'deliveryDate',
  //   headerAlign: 'center',
  //   align: 'center',
  //   minWidth: 120,
  //   showHeaderOverflow: true,
  //   showOverflow: true,
  //   sortable: true,
  //   sortType: 'string',
  // },
  {
    title: that.$l('INDEX.table_label_cargoReadyDay') || '货好时间',
    field: 'cargoReadyDay',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
    field: 'retailerPo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('INDEX.order_form_label_importerPo') || '代理商PO',
    field: 'importerPo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('form_batch_verification_error') || '批次校验错误',
    field: 'errorMsg',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
    slots: { default: 'errorMsg' }
  },
  {
    title: that.$l('INDEX.order_form_batch_label_identifyNo') || '批次识别单号',
    field: 'identifyNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('INDEX.batch_label_outBillType') || '出单类型',
    field: 'v_outBillType',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('INDEX.order_form_batch_label_dispatchPort') || '发运港口',
    field: 'v_dispatchPort',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title:
      that.$l('INDEX.order_form_batch_label_destinationPort') || '目的港口',
    field: 'v_destinationPort',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('INDEX.order_form_batch_label_packingType') || '装箱方式',
    field: 'v_packingType',
    headerAlign: 'center',
    align: 'center',
    minWidth: 90,
    showHeaderOverflow: true,
    showOverflow: true
  },

  {
    title: that.$l('INDEX.order_form_batch_label_totQty') || '产品数',
    field: 'totQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('INDEX.order_form_batch_label_totBoxQty') || '箱数',
    field: 'totBoxQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('INDEX.order_form_label_salesPersonCode') || '业务人员名字',
    field: 'salesPersonName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_bizPersonCode') || '跟单人员名字',
    field: 'bizPersonName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_custCode') || '下单客户',
    field: 'custName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_endCustCode') || '终端客户',
    field: 'endCustName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_scmCode') || '执行工厂',
    field: 'v_scmCode',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_orderScmCode') || '名义工厂',
    field: 'v_orderScmCode',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  }
]
